import { ProfileFullNames, typeStateCategories } from "../Layout"
import { UpsChatting } from "./UpsChatting";
import { UpsLivecams } from "./UpsLivecams";
import { UpsVideo } from "./UpsVideo";

interface FormProps extends typeStateCategories{
    selectedShortName: string;
}

export const Ups = (props: FormProps) => {
    const { state, selectedShortName } = props;
    const [category] = state;
    return (
        <>
            {category === 'videos' && <UpsVideo modelName={ProfileFullNames[selectedShortName as keyof typeof ProfileFullNames]} />}
            {category === 'livecams' && <UpsLivecams />}
            {category === 'chatting' && <UpsChatting />}
        </>
    )
}